import { BACKEND_URL } from '@/config';

// Uploaded files are stored as relative /api/files/... paths; make them absolute for separate frontend/API hosts
export const mediaUrl = (url) => {
  if (!url) return url;
  return url.startsWith('/api/') ? `${BACKEND_URL}${url}` : url;
};
